import { render, staticRenderFns } from "./editOrderAddress.vue?vue&type=template&id=6e35a301&scoped=true"
import script from "./editOrderAddress.vue?vue&type=script&lang=js"
export * from "./editOrderAddress.vue?vue&type=script&lang=js"
import style0 from "./editOrderAddress.vue?vue&type=style&index=0&id=6e35a301&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35a301",
  null
  
)

export default component.exports